import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { SocratesSharedModule, I18NService, VersionsService } from '@socrates/socrates-shared';
import { IGroupConfig, SocratesGroupConfig } from '@socrates/common';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import {
	AppFooterComponent,
	AppHeaderComponent,
	AppLayoutComponent,
	AppSidebarComponent,
	LoginComponent,
	LogoutComponent,
	NewLoginComponent,
	PasswordConfirmComponent,
	PasswordResetComponent,
	PasswordModalComponent,
	ProfileModalComponent,
	SignupComponent,
	ProfileComponent,
	TosComponent,
	GuidelinesComponent,
	RouteGuard
} from './core';

import { ErrorResponseComponent, MissingComponent } from './errorComponents';
import { AppRoutingModule } from './app.routing';


@NgModule({
	imports: [
		AppRoutingModule,

		// Angular
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,

		// Socrates shared libs
		SocratesSharedModule.forRoot()
	],

	declarations: [
		AppComponent,
		AppFooterComponent,
		AppHeaderComponent,
		AppLayoutComponent,
		AppSidebarComponent,
		ErrorResponseComponent,
		LoginComponent,
		LogoutComponent,
		MissingComponent,
		NewLoginComponent,
		ProfileModalComponent,
		PasswordModalComponent,
		PasswordConfirmComponent,
		PasswordResetComponent,
		SignupComponent,
		ProfileComponent,
		TosComponent,
		GuidelinesComponent
	],

	providers: [
		RouteGuard,
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: IGroupConfig, useClass: SocratesGroupConfig },
		{ provide: 'liveGatewayUrl', useValue: environment.liveGatewayUrl },
		{
			provide: APP_INITIALIZER,
			useFactory: (i18n: I18NService) => async () => {
				await i18n.loadMessages();
			},
			deps: [I18NService],
			multi: true,
		},
		{
			provide: APP_INITIALIZER,
			useFactory: (versions: VersionsService) => () => versions.loadVersions(),
			deps: [VersionsService],
			multi: true,
		},
	],

	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(@Optional() @SkipSelf() parentModule: AppModule) {
		if (parentModule) {
			throw new Error('AppModule is already loaded. Import it only once.');
		}
	}
}
